export function isFunction(fn) {
  return typeof fn === 'function';
}